import React from "react";
import { Box, Container, Heading, Text, VStack, Image } from "@chakra-ui/react";
import ovarianLogo from "../assets/images/ovarian_2x.png";

function TheCause() {
  return (
    <Box minH="calc(100vh - 64px)" bg="gray.900">
      <Container maxW="container.xl" py={20}>
        <VStack spacing={12} align="center" textAlign="center">
          <Heading
            as="h1"
            size="4xl"
            color="white"
            fontWeight="bold"
            lineHeight="1.2"
          >
            The Cause
          </Heading>

          <Box maxW="300px" mx="auto">
            <Image
              src={ovarianLogo}
              alt="Ovarian Cancer Awareness"
              w="full"
              h="auto"
              href="https://ovariancanada.org"
              target="_blank"
              rel="noopener noreferrer"
            />
          </Box>

          <Text
            fontSize="xl"
            color="white"
            maxW="3xl"
            textAlign="left"
            lineHeight="1.8"
          ></Text>

          <Text
            fontSize="xl"
            color="white"
            maxW="3xl"
            textAlign="left"
            lineHeight="1.8"
          >
            Through this golf tournament, we aim to not only create memorable
            moments on the course but also make a meaningful impact in the fight
            against{" "}
            <a
              href="https://ovariancanada.org/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              Ovarian Cancer
            </a>
            . Every participant, every round played, and every donation made
            contributes to this vital cause.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
}

export default TheCause;
